import script from "./LaboratoryOrdersDatatableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./LaboratoryOrdersDatatableActions.vue?vue&type=script&setup=true&lang=js"

import "./LaboratoryOrdersDatatableActions.vue?vue&type=style&index=0&id=1288fbd0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1288fbd0"]])

export default __exports__